import {
	generateEventId,
	getMetaCookies,
	trackLeadPixel,
} from "@/components/analytics/meta_pixel_events";
import type { FormSchemaType, FormSubmitResult } from "./form_schema";
import {
	getAttributionSummary,
	getMetaCustomData,
	trackConversionWithJourney,
} from "./journey-tracker";

interface SubmitFormOptions {
	formName?: string;
	contentName?: string;
}

export async function submitForm(
	data: FormSchemaType,
	options: SubmitFormOptions = {},
): Promise<FormSubmitResult> {
	try {
		const formName = options.formName ?? "contact";
		const contentName = options.contentName ?? "Contact Form";

		// Generate eventId and fire client-side pixel for deduplication
		const eventId = generateEventId();
		trackLeadPixel({ contentName, eventId });

		// Track in Umami with journey context
		trackConversionWithJourney("form_submit", { form: formName });

		// Get Meta cookies for server-side matching
		const { fbc, fbp } = getMetaCookies();

		// Get journey/attribution data
		const attribution = getAttributionSummary();
		const metaCustomData = getMetaCustomData();

		const response = await fetch("/api/form", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({
				...data,
				eventId, // Pass for deduplication
				fbc, // Pass for matching
				fbp,
				// Journey/attribution data
				attribution,
				metaCustomData,
			}),
		});

		if (!response.ok) {
			const result = await response.json();
			return {
				success: false,
				error: result.error || "An error occurred while submitting the form",
			};
		}

		const result = await response.json();

		return {
			success: true,
			data: result.data,
		};
	} catch (error) {
		console.error("Error submitting form:", error);
		return {
			success: false,
			error: "Network error or server unavailable",
		};
	}
}
